import type { Muelle, PlaceEvent } from '../domain/scales'
import type { EventRow, TimePoint } from './types'

export interface StayDate extends TimePoint {
  differenceS: number | null
}

export interface StayDates {
  id: string
  muelle: Muelle
  arrival: StayDate
  departure: StayDate
  overdueS: number | null
  unconfirmed: boolean
}

const SECOND = 1000

const stayDate = (time: TimePoint): StayDate => ({
  ...time,
  differenceS:
    time.plannedLatest === null || time.actual === null
      ? null
      : Math.round((Date.parse(time.actual) - Date.parse(time.plannedLatest)) / SECOND),
})

const overdueS = ({ plannedLatest, actual }: TimePoint, now: number): number | null => {
  if (actual !== null || plannedLatest === null) return null
  const passed = now - Date.parse(plannedLatest)
  return passed > 0 ? Math.round(passed / SECOND) : null
}

export const stayDates = (events: readonly EventRow[], now: number): StayDates[] =>
  events
    .filter((event): event is EventRow & PlaceEvent => event.type === 'PLACE')
    .sort((a, b) => Date.parse(a.startTime) - Date.parse(b.startTime))
    .map(stay => {
      const unconfirmed = stay.times.end.actual === null && stay.actualsState === 'UNCONFIRMED'
      return {
        id: stay.id,
        muelle: stay.muelle,
        arrival: stayDate(stay.times.start),
        departure: stayDate(stay.times.end),
        overdueS: unconfirmed ? null : overdueS(stay.times.end, now),
        unconfirmed,
      }
    })
